'use strict';
import {Observable} from 'rxjs/Observable';

export class CurrentPositionObservable extends Observable {
  constructor(options, mapPosition, mapError) {
    super();

    this.options = options;
    this.mapPosition = mapPosition;
    this.mapError = mapError;
  }

  /**
   * @param {Subscriber} subscriber
   * @protected
   * @override
   */
  _subscribe(subscriber) {
    try {
      global.window.navigator.geolocation.getCurrentPosition(
        data => {
          subscriber.next(this.mapPosition ? this.mapPosition(data) : data);
          subscriber.complete();
        },
        e => subscriber.error(this.mapError ? this.mapError(e) : e),
        this.options
      );
    } catch (e) {
      subscriber.error(this.mapError ? this.mapError(e) : e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/rx-dom/CurrentPositionObservable.js